import { render, staticRenderFns } from "./PMDashboardTable.vue?vue&type=template&id=831eb8ea&scoped=true&"
import script from "./PMDashboardTable.vue?vue&type=script&lang=js&"
export * from "./PMDashboardTable.vue?vue&type=script&lang=js&"
import style0 from "./PMDashboardTable.vue?vue&type=style&index=0&id=831eb8ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831eb8ea",
  null
  
)

export default component.exports